import Fuse from "fuse.js";

document.addEventListener("alpine:init", () => {
    Alpine.data("documentFilter", () => ({
        fuse: null,
        fuseOptions: {
            threshold: 0.2,
            ignoreLocation: true,
            keys: ["title", "description", "area"],
        },
        baseDocuments: [],
        filteredResults: [],
        searchInput: "",
        documents: null,
        sortCol: null,
        sortAsc: false,
        area: "",
        searchArea: "",
        init() {
            this.documents = JSON.parse(this.$refs.documentFilter.dataset.items.replace("&quot;", '"'));
            this.baseDocuments = [...this.documents];
            this.fuse = new Fuse(this.baseDocuments, this.fuseOptions);
            this.$watch("searchArea", (value) => {
                const option = document.querySelector(`option[value="${value}"]`);
                window.location.href =
                    option.dataset.uri + (this.searchInput.length ? `?search=${this.searchInput}` : "");
            });
            const searchParam = new URLSearchParams(window.location.search).get("search");
            if (searchParam) {
                this.searchInput = searchParam;
                this.search();
            }
        },
        search() {
            if (this.searchInput.trim() !== "" || this.area) {
                if (this.area) this.filterByArea();
                if (this.searchInput.trim() !== "")
                    this.documents = this.fuse.search(this.searchInput, this.fuseOptions).map((i) => i.item);
                trackingPush({
                    event: "document_search",
                    search_term: this.searchInput,
                    search_results: this.documents.length,
                });
            } else {
                this.documents = [...this.baseDocuments];
                this.fuse = new Fuse(this.baseDocuments, this.fuseOptions);
            }
            this.sortBy(this.sortCol, false);
        },
        resetInput() {
            this.searchInput = "";
            this.search();
        },
        sortBy(col, changeDirection = true) {
            if (changeDirection && this.sortCol === col) this.sortAsc = !this.sortAsc;
            this.sortCol = col;
            this.documents.sort((a, b) => {
                const compareA = col !== "date" ? a[this.sortCol].toLowerCase() : this.getDate(a.date);
                const compareB = col !== "date" ? b[this.sortCol].toLowerCase() : this.getDate(b.date);
                if (compareA < compareB) return this.sortAsc ? 1 : -1;
                if (compareA > compareB) return this.sortAsc ? -1 : 1;
                return 0;
            });
        },
        filterByArea() {
            this.documents = this.baseDocuments.filter((item) => {
                return item.areaIds.includes(this.area);
            });
            this.fuse = new Fuse(this.documents, this.fuseOptions);
        },
        synchronizeScrollsByColumns() {
            this.$refs.searchResults.scrollLeft = this.$refs.searchColumns.scrollLeft || 0;
        },
        synchronizeScrollsByResults() {
            this.$refs.searchColumns.scrollLeft = this.$refs.searchResults.scrollLeft || 0;
        },
        getDate(dateString) {
            const [day, month, year] = dateString.split(".");

            const date = new Date(+year, +month - 1, +day);

            return date;
        },

        trackClick(event) {
            // event.preventDefault();
            const link = event.target.closest("a");

            // Search website click
            trackingPush({
                event: "document_search_click",
                search_term: this.searchInput,
                search_result_clicked: link.getAttribute("name"),
            });
        },
    }));
});
